
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bar-hire-packages",
      function () {
        return require("private-next-pages/bar-hire-packages.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bar-hire-packages"])
      });
    }
  